import { gsap } from 'gsap';
import { Draggable } from 'gsap/Draggable';
import { InertiaPlugin } from 'gsap/InertiaPlugin';
import { debounce as _debounce } from 'underscore';


export default class{

    constructor( options ) {
        this.defaults = {
        	$el    :    [],

            // shadow with
            margin :    140,

            centered : true

        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'widget_draggable_layer';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;

		if ( this.$el.length > 0 ){
			this.init();
		}
    }

    init(){
    	this.$html      = $('html');
        this.$win       = $(window);

        this.$inner     = this.$el.find( '.inner' );
        this.$draggable = this.$inner.find( '.inner-draggable' );
        this.$content   = this.$draggable.find( '.inner-content' );


        this.width = this.$content.outerWidth();

        this.addEvents( true );

        this.update();

        this.$el.addClass( 'ready' );
	}

	//---------------------------------------- EVENTS ---------------------------------------//
	addEvents( b ){
		if ( b ){

            // set draggable
            Draggable.create( this.$draggable, {
                type:"x",
                bounds: this.$inner,
                // THIS NEED INIERTIA PLUGIN!!!!!!!!!
                inertia: true     
            });

            this.draggableInstance = Draggable.get( this.$draggable );
		}
		else{

            this.draggableInstance.kill();

		}
        this.debounceResize(b);
	}

    debounceResize(b){
        if ( b ){
            // debounce resize
            this._debResize = _debounce( () => this.onResize(), 117 );
            this.$win.on( 'resize', this._debResize );
        }
        else{
            if ( this._debResize ){
                this._debResize.cancel();
                this.$win.off( 'resize', this._debResize );
            }        
        }
    }

    onResize(){
        this.update();
    }

    update(){


        this.$draggable.width( this.width + this.options.margin );

        if ( this.$inner.width() < this.$draggable.width() ){
            this.$el.addClass( 'active' );
            this.draggableInstance.enable()
        }
        else{
            this.$el.removeClass( 'active' );
            this.draggableInstance.disable()
           
        }

        if ( this.options.centered ){
            gsap.set( this.$draggable, {x: Math.max( 20, this.$inner.width()/2 - this.$draggable.width()/2 )  } );
        }
        else{
            gsap.set( this.$draggable, {x: 0 } );
        }

        this.setCurrentSelection();

        
    }

    setCurrentSelection(){
        
        // set current selection
        let $c = this.$content.find( 'li.current-menu-item' );
        if ( $c.length > 0 ){
            tox = Math.min( $c.offset().left - 20 , this.$draggable.width() - this.$inner.width() );
            //console.log( tox );
            gsap.set( this.$inner, { x: - tox } );
        }
        else{
            gsap.set( this.$inner, { x: 0 } );
        }

    }

    destroy(){
		if ( this.$el.length > 0  ){
    		this.addEvents( false );
    	}
    }

}


